import without from 'lodash/without';
import { defineVuexModule } from '../helpers';

export type Category = {
  id: number;
  color: string;
  name: string;
  type: 'seated' | 'ga';
  capacity: number;
  bestAvailable?: boolean;
  max?: number;
  price: number;
};

export default defineVuexModule({
  namespaced: true,
  state: {
    categories: [] as Category[],
    categoryCollection: [] as Category[],
    unassignedCount: 0,
    unassignedGa: 0,
    assignedList: [] as {
      category: Category;
      count: number;
    }[],
  },

  getters: {},

  actions: {
    loadCategories(context, categories: Category[]) {
      context.commit('updateCategories', categories);
    },
    changeCategory(context, category: Category) {
      context.commit('changeCategory', category);
    },
    addCategoryToStore(context, category: Category) {
      context.commit('addCategory', category);
    },
    deleteCategoryFromStore(context, category: Category) {
      context.commit('deleteCategory', category);
    },
    updateAssignedList(
      context,
      catStats: {
        category: Category;
        count: number;
      }[]
    ) {
      context.commit('updateAssignedList', catStats);
    },
    changeUnassignedCount(context, count: number) {
      context.commit('changeUnassignedCount', count);
    },
    changeUnassignedGaCount(context, count: number) {
      context.commit('changeUnassignedGaCount', count);
    },
  },

  mutations: {
    updateCategories(state, categories) {
      state.categories = categories;
    },
    updateCategoryCollection(state, categories) {
      state.categoryCollection = categories;
    },
    changeCategory(state, category) {
      state.categories = state.categories.map((c) => (c.id === category.id ? category : c));
    },
    addCategory(state, category) {
      state.categories = [...state.categories, category];
    },
    deleteCategory(state, category) {
      state.categories = without(state.categories, category);
    },
    updateAssignedList(state, assignedList) {
      state.assignedList = assignedList;
    },
    changeUnassignedCount(state, count) {
      state.unassignedCount = count;
    },
    changeUnassignedGaCount(state, count) {
      state.unassignedGa = count;
    },
  },
});
